import { Component, ViewChild, OnInit, Output, ViewChildren, QueryList,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Global } from '../../../shared/global';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import {
  Lists_phongban, Lists_ngachluong, Lists_nguonkinhphi, Lists_loaikhoan, Lists_tieumuc
} from '../../../routes/menu'
import 'jquery'
import 'bootstrap'


const swal = require('sweetalert');
@Component({
    selector: 'app-dm-canboedit',
    templateUrl: './canboedit.component.html',
    //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
    styleUrls: ['./canboedit.component.scss'],
    providers: [ListService, Repository]
})


export class canboeditComponent implements OnInit {

   
    quyen_them: boolean = false;
    quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  tabselected: number = 1;
    public ngaycap: Date = null;
  inputphongbans: any
  inputngachluongs: any;
  inputloaicanbos: any = [{ Id: 1, Name: 'Biên chế' }, { Id: 2, Name: 'Hợp đồng' }, { Id: 3, Name: 'Tập sự' }]
  inputnguonkinhphis: any;
  inputloaikhoans: any;
  inputtieumucs: any;
  inputkhoanluongthus: any;
  inputkhoanluongtrus: any;
  indLoading: boolean = false;
  
    doituongSelect: any = { Id: null, Ma_Doi_Tuong: null, Ten_Doi_Tuong: null,Ghi_Chu: null,Parent:null,Trang_Thai:null,Nhom_Doi_Tuong_ID:null,Don_Vi_Id:null,Ma_Ao:null,
      Chuc_Vu: null, Ma_So_Thue: null, Dia_Chi: null, Dien_Thoai: null, Email: null, CMND: null, Gioi_Tinh: null, Ngay_Sinh: null, Ngay_Sinh_S: null
      , Phong_Ban_Id: null, Ngach_Luong_Id: null, Loai_Can_Bo: null, He_So_Luong: null, Bac_Luong: null, Nghi_Thai_San: null, Luong_Dong_BH: null, So_Tien_Luong: null,
      CMND_NgayCap: null, CMND_NoiCap: null, CMND_NgayCapS: null, Thu_Nhaps: [], Khau_Trus: [], Phong_Bans: []
      , He_So_Luong_Truy_Linh:null
    };    
    nhomdtid:string=null;

    @ViewChild('slCapTren',{static:false}) slCapTren: NgSelectComponent;
  @Output() save: EventEmitter<any> = new EventEmitter();
  @ViewChildren("myinput") divs: QueryList<ElementRef>;
  @ViewChildren(NgSelectComponent) slcombo: QueryList<NgSelectComponent>

  public ngxCurrencyOptions = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    precision: 0,
    allowNegative: true
  };

  public ngxSLOptions = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    precision: 4,
    allowNegative: true
  };
   

    constructor( private _dataService: ListService, private repo: Repository) {
       
        
    }
  donviid: any;


  ngOnInit(): void {
    var authlogin = localStorage.getItem('currentUser');
    if (authlogin) {

      let data = JSON.parse(authlogin);
      this.donviid = data.id_don_vi;
    
    }

    this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_nguonkinhphi.id, MaGiaoDien: '', DonViId: this.donviid })
      .subscribe(response => {
        this.inputnguonkinhphis = response;
      });    
    this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_loaikhoan.id, MaGiaoDien: '', DonViId: this.donviid })
      .subscribe(response => {
        this.inputloaikhoans = response;
      });
    this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_tieumuc.id, MaGiaoDien: '', DonViId: this.donviid })
      .subscribe(response => {
        this.inputtieumucs = response;
      });


    this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_ngachluong.id, MaGiaoDien: '', DonViId: this.donviid })
        .subscribe(response => {
          this.inputngachluongs = response;
      });
    this.repo.getRequest('api/khoanluong/khoanluongtheoloai/1/' + this.donviid)
      .subscribe(response => {
        this.inputkhoanluongthus = response;
      });
    this.repo.getRequest('api/khoanluong/khoanluongtheoloai/3/' + this.donviid)
      .subscribe(response => {
        this.inputkhoanluongtrus = response;
      });
  }
  
    

    // @HostListener('document:keydown', ['$event'])
    // public handleKeyboardEvent(event: KeyboardEvent): void {
      
    //   if(event.key==="F9")
    //   {
    //       this.saveproduct();
    //   }
    //   event.stopPropagation();
     
    // }

    comboSearchFn(term: string, item: any) {
        term = term.toLowerCase();
        return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
    }
    @ViewChild("mafocus",{static:false}) mafocus : ElementRef;
  callForm: any;
  loadDataInit(nhomdoituongid: string, id: string, donviid: string) {
    this.loadDataInit1(nhomdoituongid, id, donviid);
  }
  loadDataInit2(nhomdoituongid: string, id: string, donviid: string, tentruong: any) {
    this.callForm = tentruong;
    this.loadDataInit1(nhomdoituongid, id, donviid);
  }
  loadDataInit1(nhomdoituongid: string, id: string, donviid: string) {
    this.tabselected = 1;
      var authlogin = localStorage.getItem('currentUser');
      if (authlogin) {

        let data = JSON.parse(authlogin);
        var giatri = data.ds_quyen.filter(name => name.id === nhomdoituongid.toLowerCase());
        if (giatri != null && giatri.length > 0) {
          if (giatri[0].them == true)
            this.quyen_them = true;
          else
            this.quyen_them = false;
          if (giatri[0].sua == true)
            this.quyen_sua = true;
          else
            this.quyen_sua = false;
          if (giatri[0].xoa == true)
            this.quyen_xoa = true;
          else
            this.quyen_xoa = false;
        }
      }    

      this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_phongban.id, MaGiaoDien: '', DonViId: donviid })
        .subscribe(response => {
          this.inputphongbans = response;
        });

        this.nhomdtid = nhomdoituongid;
        setTimeout(() => {
            this.mafocus.nativeElement.focus();  
        },500);
       
        this.doituongSelect ={ Id: null, Ma_Doi_Tuong: null, Ten_Doi_Tuong: null,Ghi_Chu: null,Parent:null,Trang_Thai:true,Nhom_Doi_Tuong_ID:nhomdoituongid,Don_Vi_Id:donviid,Ma_Ao:null,
          Chuc_Vu: null, Ma_So_Thue: null, Dia_Chi: null, Dien_Thoai: null, Email: null, CMND: null, Gioi_Tinh: null, Ngay_Sinh: null, Ngay_Sinh_S: null
          , Phong_Ban_Id: null, Ngach_Luong_Id: null, Loai_Can_Bo: null, He_So_Luong: null, Bac_Luong: null, Nghi_Thai_San: null, Luong_Dong_BH: null, So_Tien_Luong: null,
          CMND_NgayCap: null, CMND_NoiCap: null, CMND_NgayCapS: null, Thu_Nhaps: [], Khau_Trus: [], Phong_Bans: [],
          He_So_Luong_Truy_Linh: null, Stt: null, Tai_Khoan_Ngan_Hang: null, Ten_Ngan_Hang: null
      };
      this.ngaycap = null;
        if(id === null)
        {
            console.log("vao loaddatainit" + id);
            this.repo.getRequest("api/doituong/SinhMaDoiTuong/" + nhomdoituongid + '/'+donviid)
            .subscribe(response => {  
                console.log(response);
                this.doituongSelect.Ma_Doi_Tuong = response;
            });
          this.doituongSelect.Trang_Thai = true;
        } 
        else {
            console.log(id);
            this.repo.getRequest("api/doituongnhanvien/getmodelbyid/" + id)
            .subscribe(response => {  
                console.log(response);
              this.doituongSelect.Id = id;
              this.doituongSelect.Stt = response.Stt;
                this.doituongSelect.Ma_Doi_Tuong = response.Ma_Doi_Tuong;
                this.doituongSelect.Ten_Doi_Tuong = response.Ten_Doi_Tuong;
                this.doituongSelect.Trang_Thai = response.Trang_Thai;
                this.doituongSelect.Ghi_Chu = response.Ghi_Chu;
                this.doituongSelect.Parent = response.Parent;
              this.doituongSelect.Ma_Ao = response.Ma_Ao;
              this.doituongSelect.Phong_Ban_Id = response.Phong_Ban_Id;
              this.doituongSelect.Ngach_Luong_Id = response.Ngach_Luong_Id;
              this.doituongSelect.Loai_Can_Bo = response.Loai_Can_Bo;
              this.doituongSelect.He_So_Luong = response.He_So_Luong;
              this.doituongSelect.He_So_Luong_Truy_Linh = response.He_So_Luong_Truy_Linh;
              this.doituongSelect.Bac_Luong = response.Bac_Luong;
              this.doituongSelect.Nghi_Thai_San = response.Nghi_Thai_San;
              this.doituongSelect.Luong_Dong_BH = response.Luong_Dong_BH;
              this.doituongSelect.So_Tien_Luong = response.So_Tien_Luong;
             
                this.doituongSelect.Chuc_Vu = response.Chuc_Vu;
                this.doituongSelect.Gioi_Tinh = response.Gioi_Tinh;
                this.doituongSelect.Ngay_Sinh = response.Ngay_Sinh;
                this.doituongSelect.Ma_So_Thue = response.Ma_So_Thue;
                this.doituongSelect.Dia_Chi = response.Dia_Chi;
                this.doituongSelect.Dien_Thoai = response.Dien_Thoai;
                this.doituongSelect.Email = response.Email;
              this.doituongSelect.CMND = response.CMND;
              this.doituongSelect.Thu_Nhaps = response.Thu_Nhaps;
              this.doituongSelect.Khau_Trus = response.Khau_Trus;
              this.doituongSelect.Phong_Bans = response.Phong_Bans;
              this.doituongSelect.Phong_Bans.forEach(
                (item) => {
                  if (item.NgayApDung != null)
                    item.NgayApDung = new Date(item.NgayApDung);
                  
                }
              );

              this.doituongSelect.Tai_Khoan_Ngan_Hang = response.Tai_Khoan_Ngan_Hang;
              this.doituongSelect.Ten_Ngan_Hang = response.Ten_Ngan_Hang;

              if (response.CMND_NgayCap != null)
                this.ngaycap = new Date(response.CMND_NgayCap);
              else
                this.ngaycap = null;
              this.doituongSelect.CMND_NoiCap = response.CMND_NoiCap;
              }); 
        }
        
       
    }
   
    keyTenPress(event: any) { 
        if (event.which === 13) {
            this.slCapTren.focus();
            event.preventDefault();
          }
   }
    public closeModal(){
        this.save.emit(null);
    }
    public saveproduct() {
        if (this.doituongSelect.Ten_Doi_Tuong == null || this.doituongSelect.Ten_Doi_Tuong == "") {
            swal('Lỗi!', 'Vui lòng nhập tên đối tượng!.', 'error');
            return;
      }
      //if (this.doituongSelect.He_So_Luong != null && this.doituongSelect.He_So_Luong_Truy_Linh != null && this.doituongSelect.He_So_Luong_Truy_Linh != 0
      //  && this.doituongSelect.He_So_Luong_Truy_Linh < this.doituongSelect.He_So_Luong) {
      //  swal('Lỗi!', 'Nâng hệ số lương phải lớn hơn hệ số lương!.', 'error');
      //  return;
      //}


      this.doituongSelect.Phong_Bans.forEach(
        (item) => {
          if (item.NgayApDung != null)
            item.NgayApDungS = item.NgayApDung.getDate() + '/' + (item.NgayApDung.getMonth() + 1) + '/' + item.NgayApDung.getFullYear() + '/' + item.NgayApDung.getHours() + '/' + item.NgayApDung.getMinutes();
         
        }
      );

      if (this.ngaycap != null)
        this.doituongSelect.CMND_NgayCapS = this.ngaycap.getDate() + '/' + (this.ngaycap.getMonth() + 1) + '/' + this.ngaycap.getFullYear();
      $('#loading').show();
      this.repo.postRequest("api/doituongnhanvien/addorupdate2",this.doituongSelect)
            .subscribe(response => {  
              console.log(response);
              $('#loading').hide();
              if (response != null && response.match('-')) {
                this.doituongSelect.Id = response;
                this.doituongSelect.CallForm = this.callForm;
                this.save.emit(this.doituongSelect);
              }
              else {
                swal('Lỗi!', response, 'error');
              }
            }); 
    }
  maxcot: number = 6;

  keyComBoPress(event: any, hang: number, cot: number, luoi: number) {


    
    if (event.which === 13) {
      cot = cot + 1;

      if (cot > this.maxcot) {
        hang = hang + 1;
        cot = 1;
        if (luoi === 3) {
          if (hang === this.doituongSelect.Khau_Trus.length) {
            this.AddRowNew(this.doituongSelect.Khau_Trus);
          }
        }
        else if (luoi === 4) {
          if (hang === this.doituongSelect.Phong_Bans.length) {
            this.AddRowNewPB(this.doituongSelect.Phong_Bans);
          }
        }
        else {
          if (hang === this.doituongSelect.Thu_Nhaps.length) {
            this.AddRowNew(this.doituongSelect.Thu_Nhaps);
          }
        }

      }
      this.setComboFocus(hang, cot, luoi);
      event.preventDefault();
    }
  }
  //----------event xử lý di chuyển Enter--------------------------------------
  setComboFocus(hang: number, cot: number, luoi: number) {
    var tencombo: string = hang + '_' + cot + '_' + luoi;
    var ketqua = false;

    this.slcombo.forEach(
      (question) => {
        if (question.labelForId === tencombo) {

          ketqua = true;
          question.focus();
        }
      }
    );

    if (ketqua === false) {
      this.divs.forEach(
        (div) => {

          if (div.nativeElement.id === tencombo) {
            ketqua = true;
            div.nativeElement.focus();
          }

        }
      );
    }
  }
  RowNewClick() {
    if (this.tabselected === 3) {
      this.AddRowNew(this.doituongSelect.Khau_Trus);
    }
    else if (this.tabselected === 4) {
      this.AddRowNewPB(this.doituongSelect.Phong_Bans);
    }
    else
      this.AddRowNew(this.doituongSelect.Thu_Nhaps);
  }
  AddRowNew(ctiets: any) {
    var sp = 'bottom';
    if (ctiets.length > 9)
      sp = 'top'
    if (ctiets.length > 0) //trường hợp lớn hơn 1 thì copy dòng cuối
    {
      var row = ctiets[ctiets.length - 1];

      ctiets.push({
        showpopup: sp, Khoan_Luong_Id: row.Khoan_Luong_Id, He_So: null, So_Tien: null,
        Nguon_Id: row.Nguon_Id,  Loai_Khoan_Id: row.Loai_Khoan_Id, Tieu_Muc_Id: row.Tieu_Muc_Id
      });
    }
    else {
      ctiets.push({
        showpopup: sp, Khoan_Luong_Id: null, He_So: null, So_Tien: null,
        Nguon_Id: null, Loai_Khoan_Id: null, Tieu_Muc_Id: null
      });

    }

  }
  AddRowNewPB(ctiets: any) {
    var sp = 'bottom';
    if (ctiets.length > 9)
      sp = 'top'
    if (ctiets.length > 0) //trường hợp lớn hơn 1 thì copy dòng cuối
    {
      var row = ctiets[ctiets.length - 1];

      ctiets.push({
        showpopup: sp, Phong_BanId: row.Phong_BanId, NgayApDung: row.NgayApDung, NgayApDungS: row.NgayApDungS
      });
    }
    else {
      ctiets.push({
        showpopup: sp, Phong_BanId: null, NgayApDung: null, NgayApDungS: null
      });

    }

  }
  deleterow(index: string, luoi: number) {
    console.log(index);
    swal({
      title: 'Bạn muốn xóa dòng này phải không?',
      text: 'Dữ liệu xóa sẽ không phục hồi lại được!',
      icon: "warning",
      buttons: {
        cancel: {
          text: 'Hủy bỏ',
          value: false,
          visible: true,
        },
        confirm: {
          text: 'Đồng ý',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    })
      .then(willDelete => {
        if (willDelete) {
          if (luoi === 3)
            this.doituongSelect.Khau_Trus.splice(index, 1);
          else if (luoi === 4)
            this.doituongSelect.Phong_Bans.splice(index, 1);
            else
            this.doituongSelect.Thu_Nhaps.splice(index, 1);
        }
      });
  }
  selectedTab(tab: number) {
    this.tabselected = tab;
    if (tab === 2) {
      setTimeout(() => {
        this.setComboFocus(0, 1, 1);
      }, 100);
    }
    else if (tab === 3)
    {
      setTimeout(() => {
        this.setComboFocus(0, 1, 3);
      }, 100);
    }
    else {
      setTimeout(() => {
        this.mafocus.nativeElement.focus();
      }, 100);
    }

  }

   


}
